module.exports = __webpack_public_path__ + "media/components/shared/images/ShareIcon-5a889a5ac3d22cf0273173cd458404bc.png";